import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import {nameValidation, emailValidation} from '../../../../utils/itemValidation';
import {cloneArray} from '../../../../utils/data';
import {getWishlistProductUrl, getMinPrice} from '../../../../utils/product';

// import * as commonActionCreators from '../../../../actions/common';
import * as productActionCreators from '../../../../actions/product';
import * as userActionCreators from '../../../../actions/user';
let allActionCreators = Object.assign({}, productActionCreators, userActionCreators);


class WishlistProduct extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);
		this.state = {
      product: null,
    };
	}

	componentDidMount() {
    this.props.productFetchBySku(this.props.sku)
    .then((respData) => {
      this.setState({ product: respData.success });
    });
  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  removeFromWishlist() {
    this.props.userWishlistRemoveItem(this.props.wishlistId, this.props.itemId)
    .then((respData) => {
      this.props.userGetWishlists()
      .then((respData) => {
        this.props.userSaveWishlists(respData.wishlists);
      });
    });
  }

  getImageUrl() {
    if(!this.state.product && !this.state.product.sku) {
      return '';
    }
    return ('https://dd2-temp-img.s3.amazonaws.com/' + this.state.product.sku + '/0.jpg');
  }

	render() {

    let pName = this.state.product ? this.state.product.name : '';

		return <div className='WishlistProduct'>
      {this.state.product === null ?
        <div className='loadingPlaceholder'>
          <div className='lpImg'>
            <img src='https://ddw2.diamondsdirect.com/img/loading.gif' />
          </div>
          <div className='lbText'>Loading</div>
        </div> :
        <div className='productWrapper'>
          <div className='productImageWrapper' onClick={() => this.internalNav(getWishlistProductUrl(this.state.product))}>
            <img src={this.getImageUrl()} />
          </div>
          <div className='productNameWrapper' onClick={() => this.internalNav(getWishlistProductUrl(this.state.product))}>
            <div className='shareIcon' style={{display: 'none'}}>
              <img src='https://ddw2.diamondsdirect.com/img/account/share.svg' />
            </div>
            <div className='productNameValue'>{pName.replace(/Ã©/g, 'é')}</div>
          </div>
          <div className='productPriceWrapper'>${getMinPrice(this.state.product)}</div>
          <div className='productNoteWrapper' style={{display: 'none'}}>add note</div>
          <div className='productRemoveIcon' onClick={::this.removeFromWishlist}>
            <img src='https://ddw2.diamondsdirect.com/img/account/smallx.svg' />
          </div>
        </div>
      }
        
		</div>;
	}
}
export default WishlistProduct;

function mapStateToProps(state) {
  return {
    common: state.common,
    user: state.user,
  };
}

export const WishlistProductContainer = connect(
  mapStateToProps,
  allActionCreators
)(WishlistProduct);


// WEBPACK FOOTER //
// ./src/components/views/account/blocks/WishlistProduct.jsx